var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showPredictionList)?_c('PredictionList',{on:{"raceSelected":function($event){return _vm.raceSelected($event)}}}):_vm._e(),(_vm.showRaceDetail)?_c('RaceDetail',{attrs:{"raceId":_vm.raceId,"race":_vm.race}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }